// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__33Jp-","colMin":"styles_colMin__3ZLfT","colCheckbox":"styles_colCheckbox__vjjcT"};